/* eslint-disable */
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import { useNav } from 'src/onboarding/hooks/nav';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import Analytics from '@web-solutions/module-analytics';
import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={styles.page}>
      {currentIndex !== 0 && (
        <div className={styles.back} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.wrapperInfo}>
        <div className={styles.title}>
          <Title>{t('onboarding.beforeAfter.before')}</Title>
          <Title>{t('onboarding.beforeAfter.after')}</Title>
        </div>

        <div className={styles.imageBefore}></div>
        <div className={styles.imageAfter}></div>
      </div>

      <Title tag='h3' className={styles.subTitle}>
        {t('onboarding.beforeAfter.title')}
      </Title>
      <div className={styles.overlay}></div>
      <div className={styles.blur}></div>

      <Button
        onClick={() => {
          Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
            page: 'before-after',
          });
          onNext();
        }}
        title={t('onboarding.beforeAfter.continue')}
      />
    </div>
  );
}

export default Page;
